import React, { FC, PropsWithChildren, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

import { OrderStep } from 'app/pages/order/redux/model/order-step';
import { selectReachedStep } from 'app/pages/order/redux/order-selector';
import { OrderStepService } from 'app/pages/order/services/order-step-service';
import { resetOrderStateForNewAccountActionCreator } from 'app/pages/order/redux/action-creators/reset-order-state-for-new-account-action-creator';
import { useAppDispatch } from 'app/hooks/thunk-hooks';
import { Spinner } from 'app/components/spinner';

interface Props {
    orderStep: OrderStep;
}

export const ProtectedOrderStepRoute: FC<PropsWithChildren<Props>> = (props) => {
    const { orderStep, children } = props;
    const reachedStep = useSelector(selectReachedStep);
    const dispatch = useAppDispatch();
    const leavingSuccessPage = reachedStep === OrderStep.SUCCESS && orderStep !== OrderStep.SUCCESS;

    useEffect(() => {
        if (leavingSuccessPage) {
            dispatch(resetOrderStateForNewAccountActionCreator());
        }
    }, [dispatch, leavingSuccessPage]);

    if (!OrderStepService.canAccessStep(orderStep, reachedStep)) {
        return <Navigate to={OrderStepService.getStepPath(reachedStep)} replace={true} />;
    }

    if (leavingSuccessPage) {
        return <Spinner />;
    }

    return children;
};
